export const DEFAULT_CURRENCY = "AED";
export const DEFAULT_LOCALE = "en";
export const DEFAULT_MEASUREMENT = "imperial";
export const DEFAULT_COUNTRY = "AE";
export const storageUserCountry = "countryJeo";
export const supportedLang = {
  en: "en",
  ar: "ar",
  ru: "ru",
  zh: "zh",
  de: "de",
  fr: "fr",
  tr: "tr",
};

export const allowedSupportedLocales = ["en", "ar", "ru", "zh", "de", "fr", "tr"];

export const regexForLangAndCountryCode = "/([a-z]{2}-[a-z]{2})/(.*)?";
export const regexForLang = "^/([a-z]{2})/(.*)?";

export const articleTypeWithoutDhub = ["blog", "blogs", "offer", "offers"];
export const offersArticleTypeList = ["offer", "offers", "offers-and-deals"];

export const showOnlineExclusiveFeatureFlag = false;
export const showMicroComponentsFeatureFlag = false;
export const showNpsFeatureFlag = false;
export const hideDiscoverButton = false;
